import {emptyValueSymbol} from '@netx/core-attribute/constants';

/**
 * @param value Value
 * @return Is empty value
 */
export const isEmptyValue = (value: any) => {
	if (value === emptyValueSymbol) return true;
	if (value === void 0 || value == null) return true;
	if (value.length === 0) return true;
	if (typeof value === 'string' && value.trim() === '') return true;
	if (Array.isArray(value) && value[0] === '') return true;
	return false;
};

export default isEmptyValue;
